// extracted by mini-css-extract-plugin
export default {"tooltipPopper":"OTooltip_tooltipPopper__HnyZ6","tooltip":"OTooltip_tooltip__byB55","capitalized":"OTooltip_capitalized__gvkW-","small":"OTooltip_small__tl94I"};